export default function TestList({ tests, onSelect }) {

  if(!tests.length){
    return <div className="emptyState">No tests found</div>;
  }

  return (

    <div className="tableWrapper">

      <table className="lmsTable">

        <thead>
          <tr>
            <th>Name</th>
            <th>Difficulty</th>
            <th>Language</th>
            <th>Topics</th>
            <th>Sections</th>
            <th></th>
          </tr>
        </thead>

        <tbody>

          {tests.map(t=>(

            <tr key={t.ID}>

              <td className="testName">
                {t.testName}
              </td>

              <td>
                <span className="badge difficulty">
                  {t.difficultyLevel}
                </span>
              </td>

              <td>
                {t.testLanguage}
              </td>
<td>
                {t.topics?.length
                  ? t.topics.join(", ")
                  : "—"
                }
              </td>
              <td>
                {t.sections?.length
                  ? t.sections.join(", ")
                  : "—"
                }
              </td>

              <td>

                <button style={{fontSize:"14px",color:"#ffffff",background:"rgba(144, 202, 249,1)",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
                  className="selectBtn"
                  onClick={()=>onSelect(t)}
                >
                  Select
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>
<style>{`.tableWrapper{
  width:100%;
  
}

.lmsTable{
  width:100%;
  border-collapse:collapse;
  font-size:14px;
}

.lmsTable thead{
  background:#f9fafb;
}

.lmsTable th{
  text-align:left;
  padding:12px;
  font-weight:600;
  color:#374151;
  border-bottom:1px solid #e5e7eb;
}

.lmsTable td{
  padding:12px;
  border-bottom:1px solid #f1f1f1;
}

.lmsTable tbody tr{
  transition:background .15s;
}

.lmsTable tbody tr:hover{
  background:#f8fafc;
}

.testName{
  font-weight:500;
}

.badge{
  padding:4px 8px;
  border-radius:6px;
  font-size:12px;
  background:#eef2ff;
  color:#3730a3;
}

.selectBtn{
  background:#2563eb;
  border:none;
  color:white;
  padding:6px 12px;
  border-radius:6px;
  cursor:pointer;
  font-size:13px;
}

.selectBtn:hover{
  background:#1d4ed8;
}

.emptyState{
  padding:40px;
  text-align:center;
  color:#6b7280;
}`}</style>
    </div>

  );

}